import { splitString } from "../strings";

export function parsDateTimeInMinutes(time: string): number {
  const time_arr = splitString(time, ":");
  const result = parseInt(time_arr[0]) * 60 + parseInt(time_arr[1]);
  return result;
}

export function getMsTime(ms: number): {
  days: number;
  hours: number;
  minutes: number;
} {
  const seconds = Math.floor(ms / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  minutes = minutes - hours * 60;
  hours = hours - days * 24;

  return {
    days: days,
    hours: hours,
    minutes: minutes,
  };
}
